import React, { useEffect } from "react";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import hering_img from "../../../img/hearing-exam.jpg";
import hering_img2 from "../../../img/ear-measurements.jpg";
import hering_img3 from "../../../img/Hearing-Implants.jpg";
import hering_img4 from "../../../img/hearing-aids-Repair.jpg";
import "../Services/Service.css";
import { Link, useLocation } from "react-router-dom";
import { Helmet } from 'react-helmet-async';

export default function HearingImplants() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return (
    <>
        <Helmet>
      <title>Hearing Implant Singapore | Ear Implants for Hearing</title>
        <meta name="description" content="For severe hearing loss, implanted hearing aids may benefit you more than traditional ones. Book a consultation today to see whether you're eligible!" />
        <meta property="og:title" content="Hearing Implant Singapore | Ear Implants for Hearing"></meta>
        <meta property="og:description" content="For severe hearing loss, implanted hearing aids may benefit you more than traditional ones. Book a consultation today to see whether you're eligible!"></meta>
    </Helmet>
      <Header />
      <section className="hearing_service">
        <div className="container">
          <h1 className="Heading_text">Hearing Implants</h1>
        </div>
      </section>

      <section className="Singapore">
        <div className="container">
          <div className="row align-items-center">
            <div className="  col-lg-6">
              <div className="service_img">
                <img src={hering_img3} className="img-fluid w-100" />
              </div>
            </div>
            <div className="col-lg-6">
              <div className="Sing_text">
                <h5>What Are Hearing Implants?</h5>
                <h1>Hearing Implants in Singapore</h1>
                <p>
                  Hearing implants, or Cochlear implants are small complex
                  devices that enable individuals with hearing losses to hear
                  the sounds around them. The implants bypass damaged areas of
                  the ear and directly stimulate the auditory nerve. The implant
                  consists of an external portion that is behind the ear, and an
                  internal portion placed inside the ear surgically. Hearing
                  implants improve the quality of one’s hearing ability when
                  they are not able to receive enough benefit from the hearing
                  aids.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Hearing Test Services We Provide */}
      {/* <section className="Hearing_Test_Services">
        <div className="container">
          <h1 className="Heading_text">Hearing Test Services We Provide</h1>
          <nav>
            <div class="nav nav-tabs" id="nav-tab" role="tablist">
              <button
                class="nav-link active"
                id="nav-home-tab"
                data-bs-toggle="tab"
                data-bs-target="#nav-home"
                type="button"
                role="tab"
                aria-controls="nav-home"
                aria-selected="true"
              >
                PTA Test
              </button>
              <button
                class="nav-link"
                id="nav-profile-tab"
                data-bs-toggle="tab"
                data-bs-target="#nav-profile"
                type="button"
                role="tab"
                aria-controls="nav-profile"
                aria-selected="false"
              >
                Tympanometry
              </button>
              <button
                class="nav-link"
                id="nav-contact-tab"
                data-bs-toggle="tab"
                data-bs-target="#nav-contact"
                type="button"
                role="tab"
                aria-controls="nav-contact"
                aria-selected="false"
              >
                ABR / ASSR
              </button>
            </div>
          </nav>
          <div class="tab-content" id="nav-tabContent">
            <div
              class="tab-pane fade show active"
              id="nav-home"
              role="tabpanel"
              aria-labelledby="nav-home-tab"
            >
              <h5>Pure Tone Audiometry (PTA) Test</h5>
              <p>
                PTA is the most basic form of audiometry test that is commonly
                used to assess and identify the hearing levels of an individual,
                and determining the level and type of hearing loss, and
                therefore providing a basis for diagnosis and hearing
                management. After otoscopy, PTA is then performed, whereby
                sounds of different frequencies and volume are presented to an
                individual
              </p>
            </div>
            <div
              class="tab-pane fade"
              id="nav-profile"
              role="tabpanel"
              aria-labelledby="nav-profile-tab"
            >
              <h5>Tympanometry</h5>
              <p>
                Tympanometry is a test done to examine the movement of the
                eardrum in response to changes in pressure. The test allows our
                audiologists to detect if there is fluid in the middle ear,
                infections, tears to the membrane behind the middle ear, or any
                problems with the Eustachian tube that connects the ear to the
                throat and nose.
              </p>
            </div>
            <div
              class="tab-pane fade"
              id="nav-contact"
              role="tabpanel"
              aria-labelledby="nav-contact-tab"
            >
              <h5>
                Auditory Brainstem Response (ABR) / Auditory Steady-State
                Response (ASSR)
              </h5>
              <p>
                ABR / ASSR are safe and painless tests that are commonly
                performed on newborns and babies to identify how the hearing
                nerves and brain respond to sounds. It provides audiologists
                information about possible hearing loss in these infants and
                recommend the correct treatment options.
              </p>
            </div>
          </div>
        </div>
      </section> */}

      {/* Other Services */}
      <section className="Other_Services">
        <div className="container">
          <h1 className="Heading_text">Other Services</h1>
          <div className="row">
            <div className="col-md-4">
              <div class="card">
                <img src={hering_img2} class="card-img-top" alt="..." />
                <div class="card-body">
                  <Link className="" to="">
                    <h5 class="card-title">Real-Ear Measurements</h5>
                  </Link>

                  <p class="card-text">
                    Our audiologists at The Hearing Centre provide facilities on
                    ear measurements to verify the level of hearing aids used by
                    the individuals.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div class="card">
                <img src={hering_img} class="card-img-top" alt="..." />
                <div class="card-body">
                  <Link className="" to="">
                    <h5 class="card-title">Hearing Tests</h5>
                  </Link>
                  <p class="card-text">
                    At The Hearing Centre, we work closely with individuals to
                    help them understand the type and degree of hearing problems
                    they have and become a companion with them on the path
                    towards better hearing.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div class="card">
                <img src={hering_img4} class="card-img-top" alt="..." />
                <div class="card-body">
                  <Link className="" to="">
                    <h5 class="card-title">Repairs & Adjustments</h5>
                  </Link>
                  <p class="card-text">
                    At The Hearing Centre, we take utmost care of your hearing
                    aids whether they have worn out or been exposed to any
                    external environmental factor, physical damage or excessive
                    wax.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}
